import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { showOverflowDrawer } from '../../../../toolbox/functions.web';
import Icon from '../../../icons/components/Icon';
import { withPixelLineHeight } from '../../../styles/functions.web';
import TextWithOverflow from './TextWithOverflow';
const useStyles = makeStyles()((theme) => {
    return {
        contextMenuItem: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            minHeight: '40px',
            padding: '10px 16px',
            boxSizing: 'border-box',
            // transition: '0.1s',
            '& > *:not(:last-child)': {
                marginRight: theme.spacing(3)
            },
            '&:hover': {
                // backgroundColor: theme.palette.ui09 + '65'
                backgroundColor: theme.palette.default00
            },
            '&:active': {
                backgroundColor: theme.palette.default00 + '80'
            },
            '&.focus-visible': {
                boxShadow: `inset 0 0 0 2px ${theme.palette.action01Hover}`
            }
        },
        contextMenuItemWhite: {
            backgroundColor: theme.palette.ui10,
            color: theme.palette.default00,
            '&:hover': {
                // backgroundColor: theme.palette.ui09 + '65'
                backgroundColor: theme.palette.bgRoWHoverSolid,
                color: theme.palette.primary10,
            },
            '&:active': {
                backgroundColor: theme.palette.bgRoWHoverSolid
            },
            '&.focus-visible': {
                boxShadow: `inset 0 0 0 2px ${theme.palette.bgRoWHoverSolid}`,
                color: theme.palette.primary10,
            },
            '& .jitsi-icon': {
                '& svg': {
                    fill: theme.palette.iconDark,
                    '& path': {
                        fill: theme.palette.iconDark,
                    },
                    '& g': {
                        fill: theme.palette.iconDark,
                    }
                }
            },
        },
        selected: {
            // borderLeft: `3px solid ${theme.palette.primary10}`,
            paddingLeft: '13px',
            // backgroundColor: theme.palette.ui09
        },
        simpleSelected: {
            paddingLeft: '13px',
            backgroundColor: theme.palette.backgroundTextSelect,
            color: theme.palette.textSelect
        },
        contextMenuItemDisabled: {
            pointerEvents: 'none'
        },
        contextMenuItemIconDisabled: {
            '& svg': {
                fill: `${theme.palette.text03} !important`
            }
        },
        contextMenuItemLabelDisabled: {
            color: theme.palette.text03,
            '&:hover': {
                background: 'none'
            },
            '& svg': {
                fill: theme.palette.text03
            }
        },
        contextMenuItemDrawer: {
            padding: '13px 16px'
        },
        contextMenuItemIcon: {
            '& svg': {
                fill: theme.palette.icon01
            }
        },
        text: {
            ...withPixelLineHeight(theme.typography.bodyShortRegular)
        },
        drawerText: {
            ...withPixelLineHeight(theme.typography.bodyShortRegularLarge)
        }
    };
});
const ContextMenuItem = ({ accessibilityLabel, backgroundColor, children, className, controls, customIcon, disabled, id, icon, onClick, onKeyDown, onKeyPress, overflowType, role = 'button', selected, testId, text, textClassName, iconClassName, participantID, variant, colorIcon, whiteUI = false, customId, customClass }) => {
    const { classes: styles, cx } = useStyles();
    const _overflowDrawer = useSelector(showOverflowDrawer);
    const style = backgroundColor ? { backgroundColor } : {};
    const onKeyPressHandler = useCallback(e => {
        // only trigger the fallback behavior (onClick) if we dont have any explicit keyboard event handler
        if (onClick && !onKeyPress && !onKeyDown && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onClick(e);
        }
        if (onKeyPress) {
            onKeyPress(e);
        }
    }, [onClick, onKeyPress, onKeyDown]);
    let tabIndex;
    if (role === 'tab') {
        tabIndex = selected ? 0 : -1;
    }
    if (role === 'button' && !disabled) {
        tabIndex = 0;
    }
    console.log("=================> noicon:", icon);
    return (React.createElement("div", { "aria-controls": controls, "aria-disabled": disabled, "aria-label": accessibilityLabel, "aria-selected": role === 'tab' ? selected : undefined, className: cx(styles.contextMenuItem, whiteUI && styles.contextMenuItemWhite, _overflowDrawer && styles.contextMenuItemDrawer, disabled && styles.contextMenuItemDisabled, selected && variant !== 'viettel' && styles.selected, selected && variant === 'viettel' && styles.simpleSelected, className, "controler-item-settings", "item-checkbox", "min-height-none", variant === 'viettel' && "controler-item-toogle"), "data-testid": testId, "data-customid": customId, id: id, key: text, onClick: disabled ? undefined : onClick, onKeyDown: disabled ? undefined : onKeyDown, onKeyPress: disabled ? undefined : onKeyPressHandler, role: onClick ? role : undefined, style: style, tabIndex: onClick ? tabIndex : undefined },
        (customIcon ? customIcon
            : icon && React.createElement(Icon, { className: cx(styles.contextMenuItemIcon, disabled && styles.contextMenuItemIconDisabled, iconClassName, 'hidden-custom'), size: 20, src: icon, color: colorIcon })),
        text && (React.createElement(TextWithOverflow, { className: cx(styles.text, _overflowDrawer && styles.drawerText, disabled && styles.contextMenuItemLabelDisabled, textClassName, "font-semibol-500"), overflowType: overflowType }, text)),
        children));
};
export default ContextMenuItem;
